<template>
	<div id="templates_registry_input" class="templates_registry" style="display:block">
		<div class="mb-3 flex-row" style="justify-content:space-between">
			<div class="mb3 flex-row">
                <div class="title-block__title">Реестр шаблонов</div>
				<div>
					<a class="title-block__btn btn-add btn-primary btn" :href="route_template_create">Добавить шаблон</a>
				</div>
			</div>
			<div class="mb-3 flex-row">
				<div>
					<button @click="showOnlyFavorites" class="title-block__btn btn-primary-reversed__no-border btn" :class="{ 'btn-favorite': active }">{{buttonText}}</button>
				</div>
			</div>
		</div>

		<div class="templates_registry__input">
			<div class="templates_registry__search-input">
				<div class="filter-table__input-wrap search-control">
					<input v-model="search"
                           @keyup.delete="onDeleteSearch()"
                           @keyup.enter="onSearch()"
                           type="text"
                           class="search-control__input form-control"
                           placeholder="Поиск"
                    >
					<button @click="onSearch()" class="search-control__input-btn reset-btn">
						<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
						</svg>
					</button>
				</div>
			</div>

<!--			<div class="templates_registry__input-btns">-->
<!--				<div>-->
<!--					<a class="title-block__btn btn-export-letter btn-primary-reversed btn hidden"-->
<!--                        :class="{ 'visible': checkedItems.some(element => element === true) }"-->
<!--                        href="#">-->
<!--                        Выгрузить-->
<!--                    </a>-->
<!--				</div>-->

<!--				<div>-->
<!--					<a class="title-block__btn btn-favorite btn-primary-reversed btn hidden" -->
<!--                        :class="{ 'visible': checkedItems.some(element => element === true) }"-->
<!--                        href="#">-->
<!--                        Избранное-->
<!--                    </a>-->
<!--				</div>-->

<!--				<div>-->
<!--					<a class="title-block__btn btn-delete btn-primary-reversed btn hidden"-->
<!--                        :class="{ 'visible': checkedItems.some(element => element === true) }"-->
<!--                        href="#">-->
<!--                        Удалить-->
<!--                    </a>-->
<!--				</div>-->
<!--			</div>-->
		</div>
	</div>

	<table class="service-table table align-middle">
		<thead>
			<tr>
<!--				<th scope="col">-->
<!--					<div class="form-check">-->
<!--						<input-->
<!--							class="form-check-input"-->
<!--							type="checkbox"-->
<!--							:value="isAllSelected"-->
<!--							@change="toggleAll($event)"-->
<!--						>-->
<!--					</div>-->
<!--				</th>-->
				<th scope="col" v-for="(elem, index) in thead" :key="index">
					<div :class="{'th-inner sortable asc': true, 'actions-row-label': elem === 'Действия'}">
						{{ elem }}
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
		<tr v-for="(row, index) in tbody" :key="index">
<!--			<td>-->
<!--				<div class="form-check">-->
<!--					<input-->
<!--						class="form-check-input"-->
<!--						type="checkbox"-->
<!--						v-model="checkedItems[index]"-->
<!--					>-->
<!--				</div>-->
<!--			</td>-->
			<td>{{ row.tbody.name }}</td>
			<td>{{ row.tbody.subject }}</td>
			<td>{{ row.tbody.created_at }}</td>
			<td>
				<div class="d-flex">
					<!-- Checkbox as Favorite Button -->
					<input
                        @click="favorite(row.id, row.tbody.favorite)"
						type="checkbox"
                        :checked="row.tbody.favorite"
						:id="'favorite-' + index"
						class="table-action table-action_favorite m-auto align-middle"
						title="Избранное"
					/>
					<!-- Остальные кнопки -->
					<a :href="route_preview + row.id" target="_blank" class="table-action table-action_preview m-auto align-middle" title="Предпросмотр"></a>
					<a :href="route_template_edit + row.id" class="table-action table-action_edit m-auto align-middle" title="Редактировать"></a>
					<button @click="clone(row.id)" class="table-action table-action_copy m-auto align-middle" title="Создать копию"></button>
					<button @click="copySource(row.tbody.body)" class="table-action table-action_html m-auto align-middle" title="Скопировать исходный код шаблона"></button>
					<button @click="deleteTemplate(row.id)" class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
				</div>
			</td>
		</tr>
	</tbody>
	</table>

	<Alert />

	<pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>

</template>

<script>

import PaginationElement from '../../../../elements/PaginationElement.vue';
import TemplatesLetters from '../../../../models/Mailings/TemplatesLetters';
import axios from 'axios';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'TemplateRegistryComponent',
    components: {
        Alert,
        PaginationElement
    },
		props: {
			route_list: String,
			route_delete: String,
			route_template_create: String,
			route_template_edit: String,
            route_clone_template: String,
            route_favorite_template: String,
            route_preview: String,
			current_page: {
				type: Number,
				default: 1
			}
		},
		data() {
			return {
                template: new TemplatesLetters({
                    route_list: this.route_list,
                    route_delete: this.route_delete,
                }),
				count: 1,
				limit: 30,
				page: 1,
				search: '',
				thead: ['Название письма', 'Тема письма', 'Дата создания', 'Действия'],
				tbody: [],
				checkedItems: [],
				favoriteItems: [],
                isFavorite: 0,
                onlyFavorites: {favorite: 1},
                active: true,
			};
		},
		computed: {
			isAllSelected() {
				return this.checkedItems.length === this.tbody.length && this.checkedItems.every(item => item);
			},
            buttonText() {
                return this.isFavorite ? 'Весь список' : 'Посмотреть избранное';
            }
		},
		methods: {
			...mapMutations('alerts', ['addAlert']),
            showOnlyFavorites: async function () {
                if (this.isFavorite === 0) {
                    this.isFavorite = 1;
                    await this.loadTable();
                } else {
                    this.isFavorite = 0;
                    await this.loadTable();
                }
                this.active = !this.active;
            },
            favorite: async function (template_id, isFavorite) {
                let response = await axios.post(
                    this.route_favorite_template,
                    {
                        id: template_id,
                        favorite: isFavorite
                    }
                );
            },
            loadTable: async function () {
                let response = await this.template.loadTable(this.page, this.limit, this.search, this.isFavorite ? this.onlyFavorites : null);
                this.tbody = response.tbody;
                this.count = response.pages;
            },
            deleteTemplate: function (id) {
                let conf = confirm('Вы уверены что хотите удалить шаблон?');
                if(!conf) {
                    return;
                }
                if (conf) {
                    this.template.delete(id).then(this.loadTable);
                }
            },
			toggleAll(event) {
				const isChecked = event.target.checked;
				this.checkedItems = this.tbody.map(() => isChecked);
			},
			onSearch: async function () {
				this.page = 1;
				await this.loadTable();
			},
			onDeleteSearch: async function () {
				if (this.search.trim() === '') {
					this.page = 1;
					await this.loadTable();
				}
			},
			pageChange(newPage) {
				this.page = newPage;
				this.loadTable();
			},
            clone: async function (template_id) {
                let response = await axios.post(this.route_clone_template, { id: template_id });

                if (response.data.status == 'ok') {
					this.addAlert({ type: 'success', title: 'Успешно', text: 'Шаблон успешно склонирован' });
                    await this.loadTable();
                } else {
					this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось кланировать шаблон' });
                }
            },
            copySource: async function (source) {
                await navigator.clipboard.writeText(source);
				this.addAlert({ type: 'success', title: 'Успешно', text: 'Исходный код шаблона скопирован в буфер обмена' });
            },
		},
		mounted() {
			this.checkedItems = new Array(this.tbody.length).fill(false);
			this.favoriteItems = new Array(this.tbody.length).fill(false);
            this.loadTable();
		}
	};
</script>

<style scoped lang="scss">
	.page-label {
		font-size: 18px;
		font-weight: 600;
	}
	.actions-row-label {
		text-align: center;
	}
	.templates_registry {
		margin: 0px 0px 20px 0px;
		&__input {
			display: flex;
			justify-content: space-between;
		}
		&__search-input {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 16px;
			flex: 3;
		}
		&__input-btns {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			gap: 16px;
			flex: 2;
		}
	}
	.letter-status {
		text-align: center;
		padding: 6px;
		border-radius: 6px;
		&__sent {
			background-color: #D4F8D3;
		}
		&__waiting {
			background-color: #D8EBFF;
		}
		&__error {
			background-color: #FBE7E9;
		}
	}
	.flex-row {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}
    .hidden {
		display: none;
	}
	.visible {
		display: flex;
	}
    .title-block__title{
        padding: 6px;
    }
</style>
